import { LIVE_IMAGES, PAYOUT_METHOD_BANK_IMAGE, PAYOUT_METHOD_BANK_MANUAL_IMAGE, PAYOUT_METHOD_CARD_IMAGE, PAYOUT_METHOD_GRIN_DEBIT_CARD_IMAGE, PLACEHOLDER_IMAGE } from './cdn-assets';
export const PAYOUT_PROVIDER_STRIPE = 'stripe';
export const PAYOUT_PROVIDER_PAYMENT_RAILS = 'payment_rails';
export const PAYOUT_ACCOUNT_STATUS_ACTIVE = 'active';
export const PAYOUT_METHOD_TYPE_CARD = 'card';
export const PAYOUT_METHOD_TYPE_BANK = 'bank';
export const PAYOUT_METHOD_TYPE_BANK_MANUAL = 'bank_account';
export const PAYOUT_METHOD_TYPE_GRIN_DEBIT_CARD = 'grin_debit_card';
export const PAYOUT_METHOD_ISSUE_TYPE_PHYSICAL = 'physical';
export const STRIPE_CONNECT_BUSINESS_TYPE_INDIVIDUAL = 'individual';
export const SHOW_STEPS_QUERY_PARAM = 'steps';
export const SHOW_ONBOARDING_SUCCESS_MESSAGE_QUERY_PARAM = 'success';
export const SHOW_ONBOARDING_INVALID_LINK_ERROR_QUERY_PARAM = 'invalid';
export const STRIPE_CONNECT_RETURN_URL = `payments/dashboard?${SHOW_STEPS_QUERY_PARAM}=true&${SHOW_ONBOARDING_SUCCESS_MESSAGE_QUERY_PARAM}=true`;
export const STRIPE_CONNECT_EDIT_RETURN_URL = `payments/dashboard?${SHOW_ONBOARDING_SUCCESS_MESSAGE_QUERY_PARAM}=true`;
export const STRIPE_CONNECT_REFRESH_URL = `payments/dashboard?${SHOW_ONBOARDING_INVALID_LINK_ERROR_QUERY_PARAM}=true`;
export const ONBOARDING_INCOMPLETE_BUTTON_TEXT = 'Complete';
export const ONBOARDING_COMPLETE_BUTTON_TEXT = 'Edit';
export const ONBOARDING_INVALID_LINK_ERROR_MESSAGE = 'There was an error redirecting you to Stripe, please try again.';
export const ONBOARDING_SUCCESS_MESSAGE = 'Tax information successfully updated.';
export const GRIN_CARD_ACTIVATION_SUCCESS_MESSAGE = 'GRIN debit card successfully activated.';
export const GRIN_CARD_CANCELATION_SUCCESS_MESSAGE = 'Your GRIN Pay card has been cancelled and removed from the account.';
/*
 * New payout method drawer content consts
 */
export const CHOOSE_PAYOUT_METHOD = 'choose-payout-method';
export const GRIN_CARD_INFO = 'grin-card-info';
export const GRIN_CARD_SIGNUP = 'grin-card-signup';
export const GRIN_CARD_CONFIRMATION = 'grin-card-confirmation';
export const DEBIT_CARD_ADD = 'debit-card-add';
export const DEBIT_CARD_CONFIRMATION = 'debit-card-confirmation';
export const BANK_ACCOUNT_ADD = 'bank-acount-add';
export const BANK_ACCOUNT_CONFIRMATION = 'bank-account-confirmation';
export const PAYOUT_METHOD_MODE_ADD = 'add';
export const PAYOUT_METHOD_MODE_EDIT = 'edit';
export const PAYOUT_METHOD_UPDATED_SUCCESS_MESSAGE = 'Payout method updated.';
export const PAYOUT_METHOD_REMOVED_SUCCESS_MESSAGE = 'Payout method removed.';
export const PAYOUT_METHOD_REMOVED_DEFAULT_FAILED_MESSAGE = 'Default payout methods cannot be removed. Select a new default payout method first.';
export const GRIN_CARD_ARRIVAL_TIME = '3 - 8 business days';
export const PAYOUT_CARD_STANDARD_PROCESSING_FEE_STRING = '0.6%';
export const PAYOUT_CARD_STANDARD_PROCESSING_TIME_STRING = '4 business days';
export const PAYOUT_BANK_STANDARD_PROCESSING_FEE_STRING = '$1.00';
export const PAYOUT_BANK_STANDARD_PROCESSING_TIME_STRING = '10 business days';
export const PAYOUT_BANK_MANUAL_STANDARD_PROCESSING_FEE_STRING = '$1.00';
export const PAYOUT_BANK_MANUAL_STANDARD_PROCESSING_TIME_STRING = '10 business days';
export const DEFAULT_PAYOUT_METHOD_LABEL_STRING = 'Set this as your default payout method?';
export const DEFAULT_PAYOUT_METHOD_LINE_1_STRING = 'All payments from brands will automatically be transfered to this account.';
export const DEFAULT_PAYOUT_METHOD_LINE_2_STRING = `Transfers will typically take
    ${PAYOUT_BANK_MANUAL_STANDARD_PROCESSING_TIME_STRING} to be available in your account
    and requires a standard ${PAYOUT_BANK_MANUAL_STANDARD_PROCESSING_FEE_STRING} fee.`;
export const DEFAULT_PAYOUT_METHOD_GRIN_PAY_LINE_1_STRING = 'Once a brand has issued a payment, transfers typically take 30 minutes to be available in your account.';
export const DEFAULT_PAYOUT_METHOD_GRIN_PAY_LINE_2_STRING = 'By enabling this selection, all payments from your brand partnership will automatically be transfered to this account.';
export const GRIN_CARD_DISPLAY_NAME = 'GRIN Pay';
export const GRIN_CARD_STATUS_ACTIVE = 'active';
export const GRIN_CARD_STATUS_INACTIVE = 'inactive';
export const GRIN_CARD_STATUS_CANCELED = 'canceled';
export const GRIN_CARD_SHIPPING_STATUS_PENDING = 'pending';
export const GRIN_CARD_SHIPPING_STATUS_SHIPPED = 'shipped';
export const GRIN_CARD_SHIPPING_STATUS_DELIVERED = 'delivered';
export const GRIN_CARD_SHIPPING_STATUS_RETURNED = 'returned';
export const GRIN_CARD_SHIPPING_STATUS_FAILURE = 'failure';
export const GRIN_CARD_SHIPPING_STATUS_LABEL_ESTIMATED_DELIVERY = 'Estimated Delivery';
export const GRIN_CARD_SHIPPING_STATUS_LABEL_DELIVERED = 'Delivered';
export const GRIN_CARD_SHIPPING_STATUS_LABEL_PENDING = 'Pending';
export const GRIN_CARD_SHIPPING_STATUS_LABEL_CANCELLED = 'Cancelled';
export const SHIPPING_STEP_PENDING_ID = 0;
export const SHIPPING_STEP_SHIPPED_ID = 1;
export const SHIPPING_STEP_RETURNED_ID = 2;
export const SHIPPING_STEP_FAILURE_ID = 3;
export const SHIPPING_STEP_DELIVERED_ID = 4;
export const SHIPPING_STEP_ACTIVATED_ID = 5;
export const GRIN_CARD_SHIPPING_STATUS_STEPS = {
    [GRIN_CARD_SHIPPING_STATUS_PENDING]: {
        id: SHIPPING_STEP_PENDING_ID,
        show: true,
        title: 'Processing',
        description: `Your new card will be mailed to you in ${GRIN_CARD_ARRIVAL_TIME}. Once it's delivered, return here to activate it.`
    },
    [GRIN_CARD_SHIPPING_STATUS_SHIPPED]: {
        id: SHIPPING_STEP_SHIPPED_ID,
        show: true,
        title: 'On the Way',
        description: `Your new card will be mailed to you in ${GRIN_CARD_ARRIVAL_TIME}. Once it's delivered, return here to activate it.`
    },
    [GRIN_CARD_SHIPPING_STATUS_RETURNED]: {
        id: SHIPPING_STEP_RETURNED_ID,
        show: false,
        title: 'Failed to Deliver',
        description: `We regret to inform you that we were unable to deliver your card after several attempts. For your protection, we've cancelled the card. Please login to your dashboard to reorder your card.`
    },
    [GRIN_CARD_SHIPPING_STATUS_FAILURE]: {
        id: SHIPPING_STEP_FAILURE_ID,
        show: false,
        title: 'Failed to Deliver',
        description: `We regret to inform you that we were unable to deliver your card after several attempts. For your protection, we've cancelled the card. Please login to your dashboard to reorder your card.`
    },
    [GRIN_CARD_SHIPPING_STATUS_DELIVERED]: {
        id: SHIPPING_STEP_DELIVERED_ID,
        show: true,
        title: 'Delivered',
        description: 'Your card was delivered! Click Activate My Card to start using your new GRIN Pay Debit Card.'
    },
    [GRIN_CARD_STATUS_ACTIVE]: {
        id: SHIPPING_STEP_ACTIVATED_ID,
        show: true,
        title: 'Card Activated',
        description: 'Your card has been activated and added to your payout methods.'
    }
};
export const GRIN_CARD_BUTTON_ACTIVATE_MY_CARD = 'Activate My Card';
export const GRIN_CARD_BUTTON_TRACK_MY_CARD = 'Track My Card';
export const GRIN_CARD_BUTTON_REORDER_MY_CARD = 'Reorder My Card';
export const PAYOUT_CONFIRMATIONS = {
    [GRIN_CARD_CONFIRMATION]: {
        image: PLACEHOLDER_IMAGE,
        title: 'Account Linked',
        subtitle: `Your new card will arrive in ${GRIN_CARD_ARRIVAL_TIME}. The account has been successfully verified and linked to GRIN.`,
        buttonText: 'Done'
    },
    [DEBIT_CARD_CONFIRMATION]: {
        image: PLACEHOLDER_IMAGE,
        title: 'Account Linked',
        subtitle: 'The account has been successfully verified and linked to GRIN.',
        buttonText: 'Done'
    },
    [BANK_ACCOUNT_CONFIRMATION]: {
        image: PLACEHOLDER_IMAGE,
        title: 'Account Linked',
        subtitle: 'The account has been successfully verified and linked to GRIN.',
        buttonText: 'Done'
    }
};
export const PAYOUT_METHODS_MENU = {
    [PAYOUT_METHOD_TYPE_GRIN_DEBIT_CARD]: {
        icon_url: PAYOUT_METHOD_GRIN_DEBIT_CARD_IMAGE,
        label: 'GRIN Debit Card',
        help1: 'Apply with no credit check. $0 fees waived for all',
        help2: 'instant payouts and no minimum balance required.',
        disabled: false
    },
    [PAYOUT_METHOD_TYPE_CARD]: {
        icon_url: PAYOUT_METHOD_CARD_IMAGE,
        label: 'Debit Card',
        help1: `Verify securely with your bank login. Transfers typically arrive in ${PAYOUT_CARD_STANDARD_PROCESSING_TIME_STRING}.`,
        help2: '',
        disabled: false
    },
    [PAYOUT_METHOD_TYPE_BANK]: {
        icon_url: PAYOUT_METHOD_BANK_IMAGE,
        label: 'Bank Account (Verify with Bank Login)',
        help1: 'Instant set up using secure bank login',
        help2: PAYOUT_BANK_STANDARD_PROCESSING_FEE_STRING +
            ' fee, funds available within ' +
            PAYOUT_BANK_STANDARD_PROCESSING_TIME_STRING,
        disabled: true
    },
    [PAYOUT_METHOD_TYPE_BANK_MANUAL]: {
        icon_url: PAYOUT_METHOD_BANK_MANUAL_IMAGE,
        label: 'Bank Account (Verify with Account and Routing Numbers)',
        help1: `Verify securely with your bank login. Transfers typically arrive in ${PAYOUT_BANK_MANUAL_STANDARD_PROCESSING_TIME_STRING}.`,
        help2: '',
        disabled: false
    }
};
export const GRIN_CARD_BENEFITS_INFO = [
    {
        title: 'Waive the 1.5% standard fee',
        description: 'Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus ivamus consectetur.'
    },
    {
        title: 'Instantly transfer your payouts',
        description: 'Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus ivamus consectetur.'
    },
    {
        title: 'No minimum balance required',
        description: 'Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus ivamus consectetur.'
    }
];
/**
 * Onboarding Flow Drawer Content
 */
export const STEP_PROPOSAL_ID = 0;
export const STEP_TAX_INFO_ID = 1;
export const STEP_PAYOUT_METHOD_ID = 2;
export const STEP_COMPLETE_ID = 3;
export const ONBOARDING_STEPS_PAGES = [
    {
        id: STEP_PROPOSAL_ID,
        title: 'We’re excited to have you aboard.',
        message: 'We need to gather a couple more items to get you set up.',
        image: `${LIVE_IMAGES}onboarding-step1.png`
    },
    {
        id: STEP_TAX_INFO_ID,
        title: 'Set up to recieve payouts',
        message: "It'll take just 5 minutes.",
        image: `${LIVE_IMAGES}onboarding-step1.png`
    },
    {
        id: STEP_PAYOUT_METHOD_ID,
        title: 'Set up to receive payouts',
        message: 'You’re almost finished.',
        image: `${LIVE_IMAGES}onboarding-step2.png`
    },
    {
        id: STEP_COMPLETE_ID,
        title: 'Your Creator Account is complete!',
        message: 'Be on the lookout for updates from your brand partnership.',
        image: `${LIVE_IMAGES}onboarding-step3.png`
    }
];
export const ONBOARDING_STEPS = [
    {
        title: 'Provide your taxpayer information',
        description: 'Verify your identity and information so you recieve your end-of-year income documents.'
    },
    {
        title: 'Add your payout method',
        description: 'Link a bank account or debit card to ensure payouts are delivered to you succesfully.'
    }
];
export const ONBOARDING_STEPS_TROLLEY = [
    {
        title: 'Add a payout method',
        description: 'You must provide a PayPal account to receive payouts.'
    },
    {
        title: 'Complete a tax form',
        description: 'Provide your W-9 or W-8 information.'
    }
];
export const ONBOARDING_STEPS_TROLLEY_IMAGE = `${LIVE_IMAGES}trolley-payout-onboarding.png`;
export const ONBOARDING_STEPS_TROLLEY_NEED_HELP_LINK = 'https://help.grin.co/docs/managing-payouts';
export const ONBOARDING_STEPS_TROLLEY_NEED_HELP = `Need help? Visit our creator <a href="${ONBOARDING_STEPS_TROLLEY_NEED_HELP_LINK}" target="_blank">FAQ</a>.`;
/**
 * Onboarding Flow Banner Content
 */
export const ONBOARDING_BANNER_STEPS = {
    [STEP_TAX_INFO_ID]: {
        title: 'Finish Setup',
        message: 'Add your tax information and PayPal to receive payouts.',
        onboardingButtonText: 'Get Started'
    }
};
export const PAYOUT_ACCOUNT_SUSPENDED_TEXT = 'Your account has been suspended because it violates our policy. If you believe this was done in error, please contact our support team for assistance.';
export const PAYOUT_ACCOUNT_UPDATE_REQUIRED_TEXT = 'Please immediately update your account to avoid interruptions to your brand partnerships and payouts.';
/**
 * Payouts and conversions
 */
export const PAYMENTS_TAB = 'payments_tab';
export const CONVERSIONS_TAB = 'conversions_tab';
export const PAYOUT_TYPE_PAYOUT = 'payout';
export const PAYOUT_TYPE_CONVERSION = 'conversion';
export const PAYOUT_STATUS_VOIDED = 'voided';
export const PAYOUT_STATUS_COMPLETED = 'completed';
export const PAYOUT_STATUS_OWED = 'owed';
export const PAYOUT_STATUS_PENDING = 'pending';
export const PAYOUT_STATUS_PROCESSED = 'processed';
export const PAYOUT_STATUS_FAILED = 'failed';
export const PAYOUT_STATUS_EXPIRED = 'expired';
export const PAYOUT_STATUS_CANCELED = 'canceled';
export const PAYOUT_STATUS_LABELS = {
    [PAYOUT_STATUS_OWED]: 'Owed',
    [PAYOUT_STATUS_PENDING]: 'Pending',
    [PAYOUT_STATUS_PROCESSED]: 'Paid',
    [PAYOUT_STATUS_FAILED]: 'Failed',
    [PAYOUT_STATUS_EXPIRED]: 'Expired',
    [PAYOUT_STATUS_CANCELED]: 'Canceled',
    [PAYOUT_STATUS_VOIDED]: 'Voided',
    [PAYOUT_STATUS_COMPLETED]: 'Completed'
};
export const PAYOUT_STATUS_COLORS = {
    [PAYOUT_STATUS_OWED]: '',
    [PAYOUT_STATUS_PENDING]: 'warning',
    [PAYOUT_STATUS_PROCESSED]: 'good',
    [PAYOUT_STATUS_FAILED]: 'danger',
    [PAYOUT_STATUS_EXPIRED]: 'danger',
    [PAYOUT_STATUS_CANCELED]: 'danger',
    [PAYOUT_STATUS_VOIDED]: 'danger',
    [PAYOUT_STATUS_COMPLETED]: 'good'
};
export const PAYABLE_TYPE_CONVERSION = 'unified_conversion';
export const PAYABLE_TYPE_PROPOSAL = 'proposal';
export const PAYABLE_TYPE_CAMPAIGN_JOB = 'campaign_job';
export const PAYABLE_TYPE_PRODUCT = 'product';
export const PAYABLE_TYPE_DEAL = 'deal';
export const PAYABLE_TYPE_ACTIVATION_DELIVERABLE = 'activation_deliverable';
export const PAYABLE_TYPE_ACTIVATION_BRIEF = 'activation_brief';
export const PAYABLE_TYPE_ACTIVATION_PAYMENT_CONFIG = 'activation_payment_config';
export const PAYABLE_TYPE_LABELS = {
    [PAYABLE_TYPE_CONVERSION]: 'Conversion',
    [PAYABLE_TYPE_PROPOSAL]: 'Proposal',
    [PAYABLE_TYPE_CAMPAIGN_JOB]: 'Deliverable',
    [PAYABLE_TYPE_PRODUCT]: 'Product',
    [PAYABLE_TYPE_DEAL]: 'Contract',
    [PAYABLE_TYPE_ACTIVATION_DELIVERABLE]: 'Deliverable',
    [PAYABLE_TYPE_ACTIVATION_BRIEF]: 'Proposal',
    [PAYABLE_TYPE_ACTIVATION_PAYMENT_CONFIG]: 'Contract'
};
